// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1VRLP","log":"ModalInventoryLogs_log__2wf-o","date":"ModalInventoryLogs_date__1vhIX","userName":"ModalInventoryLogs_userName__1bGtB"};